import React from "react";
import styles from "./logo-showcase.module.scss";

const logos: { label: string; svg: React.ReactNode }[] = [
  {
    label: "1 — Corner Brackets",
    svg: (
      <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="g1" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#fbbf24" />
            <stop offset="100%" stopColor="#d97706" />
          </linearGradient>
        </defs>
        <rect width="64" height="64" rx="14" fill="#18181b" />
        <rect x="10" y="10" width="3" height="18" rx="1.5" fill="url(#g1)" />
        <rect x="10" y="10" width="18" height="3" rx="1.5" fill="url(#g1)" />
        <rect x="51" y="36" width="3" height="18" rx="1.5" fill="url(#g1)" />
        <rect x="36" y="51" width="18" height="3" rx="1.5" fill="url(#g1)" />
        <text
          x="32"
          y="44"
          fontFamily="'Helvetica Neue', Arial, sans-serif"
          fontSize="26"
          fontWeight="700"
          fill="#fafafa"
          textAnchor="middle"
          letterSpacing="-1"
        >
          MG
        </text>
      </svg>
    ),
  },
  {
    label: "2 — Amber Circle Badge",
    svg: (
      <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="g2" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#fbbf24" />
            <stop offset="100%" stopColor="#d97706" />
          </linearGradient>
        </defs>
        <rect width="64" height="64" rx="14" fill="#18181b" />
        <circle
          cx="32"
          cy="32"
          r="24"
          fill="none"
          stroke="url(#g2)"
          strokeWidth="2.5"
        />
        <text
          x="32"
          y="41"
          fontFamily="'Helvetica Neue', Arial, sans-serif"
          fontSize="22"
          fontWeight="700"
          fill="#fafafa"
          textAnchor="middle"
          letterSpacing="-1"
        >
          MG
        </text>
      </svg>
    ),
  },
  {
    label: "3 — Full Amber Square",
    svg: (
      <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="g3" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#fbbf24" />
            <stop offset="100%" stopColor="#d97706" />
          </linearGradient>
        </defs>
        <rect width="64" height="64" rx="14" fill="url(#g3)" />
        <text
          x="32"
          y="43"
          fontFamily="'Helvetica Neue', Arial, sans-serif"
          fontSize="26"
          fontWeight="800"
          fill="#18181b"
          textAnchor="middle"
          letterSpacing="-1"
        >
          MG
        </text>
      </svg>
    ),
  },
  {
    label: "4 — Split Diagonal",
    svg: (
      <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="g4" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#fbbf24" />
            <stop offset="100%" stopColor="#d97706" />
          </linearGradient>
          <clipPath id="clip4">
            <rect width="64" height="64" rx="14" />
          </clipPath>
        </defs>
        <rect width="64" height="64" rx="14" fill="#18181b" />
        <polygon
          points="0,0 64,0 64,64"
          fill="#1f1f23"
          clipPath="url(#clip4)"
        />
        <rect
          width="64"
          height="64"
          rx="14"
          fill="none"
          stroke="url(#g4)"
          strokeWidth="2"
        />
        <text
          x="32"
          y="43"
          fontFamily="'Helvetica Neue', Arial, sans-serif"
          fontSize="26"
          fontWeight="700"
          fill="#fafafa"
          textAnchor="middle"
          letterSpacing="-1"
        >
          MG
        </text>
      </svg>
    ),
  },
  {
    label: "5 — Underline Accent",
    svg: (
      <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="g5" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#fbbf24" />
            <stop offset="100%" stopColor="#d97706" />
          </linearGradient>
        </defs>
        <rect width="64" height="64" rx="14" fill="#18181b" />
        <text
          x="32"
          y="38"
          fontFamily="'Helvetica Neue', Arial, sans-serif"
          fontSize="26"
          fontWeight="700"
          fill="#fafafa"
          textAnchor="middle"
          letterSpacing="-1"
        >
          MG
        </text>
        <rect x="14" y="44" width="36" height="3" rx="1.5" fill="url(#g5)" />
      </svg>
    ),
  },
  {
    label: "6 — Left Bar",
    svg: (
      <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="g6" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#fbbf24" />
            <stop offset="100%" stopColor="#d97706" />
          </linearGradient>
        </defs>
        <rect width="64" height="64" rx="14" fill="#18181b" />
        <rect x="8" y="14" width="3.5" height="36" rx="1.75" fill="url(#g6)" />
        <text
          x="36"
          y="43"
          fontFamily="'Helvetica Neue', Arial, sans-serif"
          fontSize="26"
          fontWeight="700"
          fill="#fafafa"
          textAnchor="middle"
          letterSpacing="-1"
        >
          MG
        </text>
      </svg>
    ),
  },
  {
    label: "7 — Stacked Monogram",
    svg: (
      <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="g7" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#fbbf24" />
            <stop offset="100%" stopColor="#d97706" />
          </linearGradient>
        </defs>
        <rect width="64" height="64" rx="14" fill="#18181b" />
        <text
          x="32"
          y="32"
          fontFamily="'Helvetica Neue', Arial, sans-serif"
          fontSize="20"
          fontWeight="300"
          fill="#a1a1aa"
          textAnchor="middle"
          letterSpacing="4"
        >
          M
        </text>
        <text
          x="32"
          y="50"
          fontFamily="'Helvetica Neue', Arial, sans-serif"
          fontSize="20"
          fontWeight="700"
          fill="url(#g7)"
          textAnchor="middle"
          letterSpacing="4"
        >
          G
        </text>
      </svg>
    ),
  },
  {
    label: "8 — Hexagon",
    svg: (
      <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="g8" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#fbbf24" />
            <stop offset="100%" stopColor="#d97706" />
          </linearGradient>
        </defs>
        <rect width="64" height="64" rx="14" fill="#18181b" />
        <polygon
          points="32,6 56,18 56,46 32,58 8,46 8,18"
          fill="none"
          stroke="url(#g8)"
          strokeWidth="2"
        />
        <text
          x="32"
          y="41"
          fontFamily="'Helvetica Neue', Arial, sans-serif"
          fontSize="20"
          fontWeight="700"
          fill="#fafafa"
          textAnchor="middle"
          letterSpacing="-1"
        >
          MG
        </text>
      </svg>
    ),
  },
  {
    label: "9 — Dot Grid",
    svg: (
      <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="g9" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#fbbf24" />
            <stop offset="100%" stopColor="#d97706" />
          </linearGradient>
        </defs>
        <rect width="64" height="64" rx="14" fill="#18181b" />
        {/* Decorative dots */}
        <circle cx="12" cy="12" r="2" fill="url(#g9)" opacity="0.3" />
        <circle cx="52" cy="12" r="2" fill="url(#g9)" opacity="0.3" />
        <circle cx="12" cy="52" r="2" fill="url(#g9)" opacity="0.3" />
        <circle cx="52" cy="52" r="2" fill="url(#g9)" opacity="1" />
        <text
          x="32"
          y="43"
          fontFamily="'Helvetica Neue', Arial, sans-serif"
          fontSize="26"
          fontWeight="700"
          fill="#fafafa"
          textAnchor="middle"
          letterSpacing="-1"
        >
          MG
        </text>
      </svg>
    ),
  },
  {
    label: "10 — Minimal Slash",
    svg: (
      <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="g10" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#fbbf24" />
            <stop offset="100%" stopColor="#d97706" />
          </linearGradient>
        </defs>
        <rect width="64" height="64" rx="14" fill="#18181b" />
        <text
          x="22"
          y="43"
          fontFamily="'Helvetica Neue', Arial, sans-serif"
          fontSize="24"
          fontWeight="700"
          fill="#fafafa"
          textAnchor="middle"
        >
          M
        </text>
        <line
          x1="32"
          y1="16"
          x2="32"
          y2="48"
          stroke="url(#g10)"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <text
          x="43"
          y="43"
          fontFamily="'Helvetica Neue', Arial, sans-serif"
          fontSize="24"
          fontWeight="700"
          fill="#fafafa"
          textAnchor="middle"
        >
          G
        </text>
      </svg>
    ),
  },
];

const LogoShowcase: React.FC = () => {
  return (
    <div className={styles.page}>
      <h1 className={styles.title}>Logo Options</h1>
      <p className={styles.subtitle}>
        Pick your favourite — each shown at actual favicon size (16 / 32px) and
        enlarged.
      </p>
      <div className={styles.grid}>
        {logos.map((logo, i) => (
          <div key={i} className={styles.card}>
            <div className={styles.label}>{logo.label}</div>
            <div className={styles.previews}>
              <div className={styles.large}>{logo.svg}</div>
              <div className={styles.sizes}>
                <div className={styles.s32}>{logo.svg}</div>
                <div className={styles.s16}>{logo.svg}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LogoShowcase;
